
import api from '../../api/nodeBackApi';

export const getCustomerWithCamaras = async (customerId) => {
  try {
    const response = await api.get(`/api/customerDashboard/getall`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer cameras:", error);
    throw error;
  }
};

export const uploadCustomerLogo = async (customerData, logoFile) => {
    // Validación de seguridad para evitar errores de undefined
    if (!customerData || customerData.length === 0) {
        throw new Error("No se encontró información del cliente para subir el logo.");
    }

    const customerDocId = customerData[0].id;
    const formData = new FormData();
    formData.append('logo', logoFile);

    try {
        // La instancia 'api' maneja automáticamente el header de autorización
        const response = await api.post(`/api/management/customers/updateLogo/${customerDocId}`, formData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCustomerByCustomerId = async (customerId) => {
    try {
        const response = await api.get(`/api/management/customers/byCustomerId/${customerId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getProjectsByCustomerId = async (customerId) => {
    try {
        const response = await api.get(`/api/management/customers/byCustomerId/${customerId}/projects`);
        return response.data;
    } catch (error) {
        throw error;
    }
};